export default {
    cs: {
        top: 'Nahoru',
        search: 'Vyhledat',
        new: 'Nové',
        canceled: 'Zrušeno',
        reservation_list: 'Přehled rezervací',
        language: 'Jazyk',
        select_date: 'Vyberte datum',
        select_channel: 'Vyberte kanál',
        select_range: 'Vyberte rozsah',
        preparing: 'Sekci připravujeme',
        today: 'Dnes',
        week_from: 'Týden od',
        data_saved: 'Data uložena',
        no_changes_to_save: 'Žádné změny k uložení',
        channel: 'Kanál',
        hotel_code: 'Kod hotelu',
        welcome_in: 'Vítejte v',

        //Splash
        version: 'verze',
        email: 'E-mail',
        phone: 'Telefon',
        username: 'Přihlašovací jméno',
        password: 'Heslo',
        login: 'Přihlásit se',
        USER_NOT_FOUND: 'Neplatný login nebo heslo',
        SERVER_TIMEOUT: 'Nelze se připojit k serveru',
        CONNECTION_ERROR: 'Chyba spojení, zkuste to později',
        FAIL2BAN: 'Překročen počet neplatných přihlášení. Přihlašte se prosím později',

        //Overview
        basic_information: 'Základní informace',
        free_occupied_rooms: 'Volné/Obsazené  pokoje',
        arrivals: 'Příjezdy',
        arrivals_remaining: 'Zbývající příjezdy',
        arrivals_total: 'Celkové',
        remaining_only: 'Pouze zbývající',
        departures: 'Odjezdy',
        departures_remaining: 'Zbývající odjezdy',
        departures_total: 'Celkové',
        todays_options: 'Dnešní opce',
        waitings: 'Waitingy',
        average_price: 'Průměrná cena',
        thirty_day_occupancy: 'Obsazenost 30 dnů',
        occupancy: 'Obsazenost',
        occupancy_from: 'Obsazenost od',
        occupancy_graph: 'Graf obsazenosti pokojů',
        occupancy_graph_free: 'Volné',
        occupancy_graph_occupied: 'Obsazené',
        earnings: 'Tržby',
        received_bookings: 'Přijaté rezervace',
        graph: 'Graf',
        graph_remaining_arrivals: 'Zbylé příjezdy',
        graph_occupied: 'Bydlící',
        graph_departures: 'Zbylé odjezdy',
        graph_fault: 'Závada',
        graph_free: 'Volné pokoje',
        days_1: 'Den',
        days_2: 'Dny',
        days: 'Dnů',
        graph_months: 'Měs.',
        graph_year: 'Rok',
        online_only: 'Pouze online',
        today_only: 'Pouze dnešní',
        history: 'Historie',
        forecast: 'Výhled',
        no_permission: 'Nemáte oprávnění',
        no_permission_for_display: 'Pro zobrazení hodnot nemáte dostatečná práva.',
        no_results: 'Žádné výsledky',
        unknown_error: 'Nastala neočekávaná chyba, zkuste načíst stránku znovu.',

        //Bookings
        new_booking: 'Nová rezervace',
        new_bookings: 'Nové rezervace',
        bookings_overview: 'Přehled rezervací',
        bookings_overview_all: 'Přehled všech rezervací',
        channel_manager: 'Správce kanálů - tabulka',
        channel_calendar: 'Správce kanálů - kalendář',
        edit_booking: 'Editace rezervace',
        save_booking: 'Uložit rezervaci',
        cancel_booking: 'Storno rezervace',
        uncancel_booking: 'Zrušit storno rezervace',

        //Booking edit/creation
        label: 'Název',
        source: 'Zdroj',
        order_num: 'Číslo obj.',
        order_email: 'E-mail',
        group: 'Skupina',
        arrival: 'Příjezd',
        departure: 'Odjezd',
        room_type: 'Typ pokoje',
        number_of_rooms: 'Počet pokojů',
        number_of_people: 'Počet osob',
        rooms_state: 'Stav pokojů',
        rooms_state_cleaned: 'Uklizeno',
        rooms_state_not_cleaned: 'Neuklizeno',
        rooms_state_fault: 'Závada',
        pricelist: 'Ceník',
        price_type: 'Typ ceny',
        price_mask: 'Maska cen',

        //Channel Manager
        rooms: 'Pokojů',
        free: 'Volné',
        fix: 'Fix',
        opce: 'Opce',
        tentative: 'Tentative',
        free_rooms: 'Volné pokoje',
        confirmed: 'Potvrzené',
        unconfirmed: 'Nepotvrzené',
        tri: 'TRI',
        dbl: 'DBL',
        sgl: 'SGL',
        total: 'Celkem',
        faults: 'Závady',
        note: 'Poznámka',
        note_abbr: 'Pozn.',
        save: 'Uložit',
        disable_dependency: 'Zrušit závislost',
        close: 'Zavřít',
        enable_dependency: 'Povolit závislost',
        open: 'Otevřít',

        //Guests
        current_guests: 'Aktuálně bydlící pokoje/hosté',
        expected_guests: 'Očekávané bydlící pokoje/hosté',
        current_occupancy_today: 'Dnešní obsazené pokoje/hosté',
        current_guests_short: 'Bydlící',
        guests_structure: 'Struktura hostů',
        guests_structure_foreigners: 'Cizinci',
        guests_structure_natives: 'Tuzemci',
        guests_structure_groups: 'Skupiny',
        guests_structure_individuals: 'Jednotlivci',

        //Check-in
        accept_without_booking: 'Příjem bez rezervace',

        //Checkin edit/new
        accommodation: 'Ubytování',
        accommodate: 'Ubytovat',
        room_number: 'Číslo pokoje',
        guest: 'Host',
        main: 'hlavní',
        guest_details: 'Detaily hosta',
        name: 'Jméno',
        surname: 'Přijmení',
        street: 'Ulice',
        street_number: 'Číslo popisné',
        city: 'Město',
        postal_code: 'PSČ',
        country: 'Země',
        citizenship: 'Státní občanství',
        purpose_of_stay: 'Účel pobytu',
        date_of_birth: 'Datum narození',
        place_of_birth: 'Místo narození',
        id_number: 'Číslo dokladu',
        visa: 'Vízum',
        plate_number: 'Registrační značka',
        add_guest: 'Přidat hosta',
        price_code: 'Kód ceny',
        price_per_day: 'Cena/den',
        price_total: 'Cena/celkem',
        payment_method: 'Způsob platby',
        gdpr_agreement: 'Souhlas s GDPR',
        signature: 'Podpis',
        room_numbers: 'Čísla pokojů',
        select_channel_in_settings: 'Vyberte kanál v nastavení',

        //Settings
        settings: 'Nastavení',
        logout: 'Odhlásit',
        default_channel: 'Channel manager',
        show_decimals: 'Zobrazovat desetinná místa',
        show_tentative: 'Zobrazovat Tentative rezervace',

        //Settings charts
        daily: 'Denní',
        monthly: 'Měsíční',
        chart_settings: 'Nastavení grafu',

        //Nav Menu Items
        hotel: 'Hotel',
        bookings: 'Rezervace',
        guests: 'Hosté',
        accommodated: 'Bydlící',
        checkin: 'Check-in',
        reports: 'Reporty',

        //Day names
        Mon: 'Po',
        Tue: 'Út',
        Wed: 'St',
        Thu: 'Čt',
        Fri: 'Pá',
        Sat: 'So',
        Sun: 'Ne',

        mon: 'Po',
        tue: 'Út',
        wed: 'St',
        thu: 'Čt',
        fri: 'Pá',
        sat: 'So',
        sun: 'Ne',

        Mo: 'Po',
        Tu: 'Út',
        We: 'St',
        Th: 'Čt',
        Fr: 'Pá',
        Sa: 'So',
        Su: 'Ne',

        monday: 'Pondělí',
        tuesday: 'Úterý',
        wednesday: 'Středa',
        thursday: 'Čtvrtek',
        friday: 'Pátek',
        saturday: 'Sobota',
        sunday: 'Něděle',

        //Prepositions
        from: 'Od',
        to: 'Do',

        obsazenost: 'Obsazenost',
        obsazenost_v_procentech: 'Obsazenost v %',
        trzby: 'Trzby',
        minimum_price: 'Minimální cena',

        //Pull to refresh
        pullText: 'Stáhnout pro přenačtění',
        triggerText: 'Pusťte pro přenačtení',
        loadingText: 'Načítám',
        doneText: 'Načteno',
        failText: 'Chyba načítání',

        Jan: 'Led',
        Feb: 'Úno',
        Mar: 'Bře',
        Apr: 'Dub',
        May: 'Kvě',
        Jun: 'Čer',
        Jul: 'Čvc',
        Aug: 'Srp',
        Sep: 'Zář',
        Oct: 'Říj',
        Nov: 'Lis',
        Dec: 'Pro',

        nothing_found: 'Nic nenalezeno',
        ok: 'OK',
        login_expired: 'Vaše přihlášení vypršelo. Pro pokračování se znovu přihlaste',
        hotel_not_found: 'Hotel nenalezen',
        room_already_booked: 'Pokoj je v tomto období již obsazen',
        room_graph: 'Graf pokojů',
        create_reservation: 'Vytvořit rezervaci',
        blocation: 'Blokace',
        cancel: 'Zrušit',
        floor: 'Patro',
        account_num: 'Účet č.',
        save_room: 'Uložit pokoj',
        room_saved: 'Pokoj uložen',
        master: 'Hlavní',
        address: 'Adresa',
        house_number: 'Číslo popisné',
        zip_code: 'PSČ',
        other_info: 'Další údaje',
        reason: 'Důvod',
        out_of_order: 'Pokoj mimo provoz',
        finalize: 'Uzavřeno',
        guest_card: 'Karta profilu',
        price_per_room_and_night: 'Cena za pokoj a noc',
        unlimited: 'Neomezeně',
        really_cancel: 'Opravdu si přejete rezervaci stornovat?',
        really_restore: 'Opravdu si přejete zrušit storno rezervace?',
        reservation_restored: 'Storno zrušeno',
        error_restoring_reservation: 'Chyba při rušení storna rezervace',
        reservation_canceled: 'Rezervace stornována',
        error_canceling_reservation: 'Chyba při rušení rezervace',
        yes: 'Ano',
        no: 'Ne',
        create_checkin: 'Ubytovat',
        checkin_done: 'Ubytování dokončeno',
        checkin_disabled_message: 'Pokoj je možné ubytovat pokud jsou vyplněné povinné údaje o hostech – precheckin (<i class="icon icon--person-check-fill"></i>) a pokud je přidělené číslo pokoje.',
        save_prices: 'Uložit ceny',
        fill_all_prices: 'Je třeba vyplnit všechny položky masky cen',
        no_rooming_checkin: 'Rezervace nemá přidělené pokoje. Pokud chcete rezervaci ubytovat, upravte rezervaci a přiřaďte všem hostům pokoje.',
        edit_reservation: 'Upravit rezervaci'
    },
    en: {
        top: 'TOP',
        search: 'Search',
        new: 'New',
        canceled: 'Canceled',
        reservation_list: 'Bookings list',
        language: 'Language',
        select_date: 'Select date',
        select_channel: 'Select channel',
        select_range: 'Select range',
        preparing: 'We are preparing the section',
        today: 'Today',
        week_from: 'Week from',
        data_saved: 'Data saved',
        no_changes_to_save: 'No changes to save',
        channel: 'Channel',
        hotel_code: 'Hotel code',
        welcome_in: 'Welcome to',

        //Splash
        version: 'Version',
        email: 'E-mail',
        phone: 'Phone',
        username: 'Username',
        password: 'Password',
        login: 'Log-in',
        USER_NOT_FOUND: 'Invalid log-in or password',
        SERVER_TIMEOUT: 'Server timeout, please try it later',
        CONNECTION_ERROR: 'Connection error, please try it later',
        FAIL2BAN: 'Invalid login count exceeded. Please log in later',

        //Overview
        basic_information: 'Basic information',
        free_occupied_rooms: 'Free/Occupied rooms',
        arrivals: 'Arrivals',
        arrivals_remaining: 'Remaining arrivals',
        arrivals_total: 'Total',
        remaining_only: 'Only remaining',
        departures: 'Departures',
        departures_remaining: 'Remaining departures',
        departures_total: 'Total',
        todays_options: 'Today\'s options',
        waitings: 'Waitings',
        average_price: 'Average price',
        thirty_day_occupancy: '30 days occupancy',
        occupancy: 'Occupancy',
        occupancy_from: 'Occupancy from',
        occupancy_graph: 'Room occupancy chart',
        occupancy_graph_free: 'Free',
        occupancy_graph_occupied: 'Occupied',
        earnings: 'Revenues',
        received_bookings: 'Received bookings',
        graph: 'Graph',
        graph_remaining_arrivals: 'Remaining arr.',
        graph_occupied: 'Accomodated',
        graph_departures: 'Remaining dep.',
        graph_fault: 'Fault',
        graph_free: 'Free rooms',
        days_1: 'Day',
        days_2: 'Days',
        days: 'Days',
        graph_months: 'Mon.',
        graph_year: 'Year',
        online_only: 'Online only',
        today_only: 'Today\'s Only',
        history: 'History',
        forecast: 'Forecast',
        no_permission: 'No permission',
        no_permission_for_display: 'You don\'t have sufficient rights to view the values.',
        no_results: 'No results',
        unknown_error: 'An unexpected error has occurred, please try to refresh the page.',

        //Bookings
        new_booking: 'New booking',
        new_bookings: 'New bookings',
        bookings_overview: 'Booking overview',
        bookings_overview_all: 'Overview of all reservations',

        channel_manager: 'Channel manager - table',
        channel_calendar: 'Channel manager - calendar',
        edit_booking: 'Edit booking',
        save_booking: 'Save booking',
        cancel_booking: 'Cancellation reservation',
        uncancel_booking: 'Cancel cancellation',

        //Booking edit/creation
        label: 'Label',
        source: 'Source',
        order_num: 'Order num.',
        order_email: 'E-mail',
        group: 'Group',
        arrival: 'Arrival',
        departure: 'Departure',
        room_type: 'Room type',
        number_of_rooms: 'Number of rooms',
        number_of_people: 'Number of people',
        rooms_state: 'Room condition',
        rooms_state_cleaned: 'Cleaned',
        rooms_state_not_cleaned: 'Uncleaned',
        rooms_state_fault: 'Fault',
        pricelist: 'Pricelist',
        price_type: 'Price type',
        price_mask: 'Price mask',

        //Channel Manager
        rooms: 'Rooms',
        free: 'Free',
        fix: 'Fix',
        opce: 'Options',
        tentative: 'Tentative',
        free_rooms: 'Free rooms',
        confirmed: 'Confirmed',
        unconfirmed: 'Unconfirmed',
        tri: 'TRI',
        dbl: 'DBL',
        sgl: 'SGL',
        total: 'Total',
        faults: 'Faults',
        note: 'Note',
        note_abbr: 'Note',
        save: 'Save',
        disable_dependency: 'Disable dependency',
        close: 'Close',
        enable_dependency: 'Enable dependency',
        open: 'Open',

        //Guests
        current_guests: 'Currently occupied rooms/guests',
        expected_guests: 'Expected resident rooms/guests',
        current_occupancy_today: 'Today\'s occupied rooms/guests',
        current_guests_short: 'Accommodated',
        guests_structure: 'Guest structure',
        guests_structure_foreigners: 'Foreigners',
        guests_structure_natives: 'Natives',
        guests_structure_groups: 'Groups',
        guests_structure_individuals: 'Individuals',

        //Check-in
        accept_without_booking: 'Accept without booking',

        //Checkin edit/new
        accommodation: 'Accommodation',
        accommodate: 'Accommodate',
        room_number: 'Room number',
        guest: 'Guest',
        main: 'Main',
        guest_details: 'Guest details',
        name: 'Name',
        surname: 'Surname',
        street: 'Street',
        street_number: 'Street number',
        city: 'City',
        postal_code: 'ZIP code',
        country: 'Country',
        citizenship: 'Citizenship',
        purpose_of_stay: 'Purpose of stay',
        date_of_birth: 'Date of birth',
        place_of_birth: 'Place of birth',
        id_number: 'ID number',
        visa: 'Visa',
        plate_number: 'Car plate number',
        add_guest: 'Add guest',
        price_code: 'Price code',
        price_per_day: 'Price/Day',
        price_total: 'Price/Total',
        payment_method: 'Payment method',
        gdpr_agreement: 'GDPR agreement',
        signature: 'Signature',
        room_numbers: 'Assigned rooms',
        select_channel_in_settings: 'Select a channel in the settings',

        //Settings
        settings: 'Settings',
        logout: 'Log-out',
        default_channel: 'Channel manager',
        show_decimals: 'Show decimal places',
        show_tentative: 'Show Tentative reservations',

        //Settings charts
        daily: 'Daily',
        monthly: 'Monthly',
        chart_settings: 'Chart settings',

        //Nav Menu Items
        hotel: 'Hotel',
        bookings: 'Bookings',
        guests: 'Guests',
        accommodated: 'Accommodated',
        checkin: 'Check-in',
        reports: 'Reports',

        //Day names
        Mon: 'Mon',
        Tue: 'Tue',
        Wed: 'Wed',
        Thu: 'Thu',
        Fri: 'Fri',
        Sat: 'Sat',
        Sun: 'Sun',

        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',

        Mo: 'Mo',
        Tu: 'Tu',
        We: 'We',
        Th: 'Th',
        Fr: 'Fr',
        Sa: 'Sa',
        Su: 'Su',

        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',

        //Prepositions
        from: 'From',
        to: 'To',

        obsazenost: 'Occupancy',
        obsazenost_v_procentech: 'Occupancy in %',
        trzby: 'Revenues',
        minimum_price: 'Minimum price',

        //Pull to refresh
        pullText: 'Pull to reload',
        triggerText: 'Let go to reload',
        loadingText: 'Loading',
        doneText: 'Loaded',
        failText: 'Error loading',

        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'Mar',
        Apr: 'Apr',
        May: 'May',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Aug',
        Sep: 'Sep',
        Oct: 'Oct',
        Nov: 'Nov',
        Dec: 'Dec',

        nothing_found: 'Nothing found',
        ok: 'OK',
        login_expired: 'Your login has expired. Please log in again to continue',
        hotel_not_found: 'Hotel not found',
        room_already_booked: 'The room is already occupied during this period',
        room_graph: 'Room Chart',
        create_reservation: 'Create Reservation',
        blocation: 'Blocation',
        cancel: 'Cancel',
        floor: 'Floor',
        account_num: 'Account num.',
        save_room: 'Save the room',
        room_saved: 'Room saved',
        master: 'Master',
        address: 'Address',
        house_number: 'House number',
        zip_code: 'ZIP code',
        other_info: 'More information',
        reason: 'Reason',
        out_of_order: 'Room out of service',
        finalize: 'Closed',
        guest_card: 'Profile tab',
        price_per_room_and_night: 'Price/room and night',
        unlimited: 'Unlimited',
        really_cancel: 'Are you sure you want to cancel your reservation?',
        really_restore: 'Are you sure you want to restore your reservation?',
        reservation_restored: 'Reservation restored',
        error_restoring_reservation: 'Error restoring reservation',
        reservation_canceled: 'Reservation canceled',
        error_canceling_reservation: 'Error canceling reservation',
        yes: 'Yes',
        no: 'No',
        create_checkin: 'Check-in',
        checkin_done: 'Check-in done',
        checkin_disabled_message: 'The room can be accommodated if the mandatory guest data – precheckin (<i class="icon icon--person-check-fill"></i>) is filled in and the room number is assigned.',
        save_prices: 'Save prices',
        fill_all_prices: 'All items of the price mask must be filled in',
        no_rooming_checkin: 'The booking has no assigned rooms. If you want to check in a booking, edit the booking and assign rooms to all guests.',
        edit_reservation: 'Edit reservation'
    },
    sk: {
        top: 'Hore',
        search: 'Vyhľadať',
        new: 'Nové',
        canceled: 'Zrušené',
        reservation_list: 'Prehľad rezervácií',
        language: 'Jazyk',
        select_date: 'Vyberte dátum',
        select_channel: 'Vyberte kanál',
        select_range: 'Vyberte rozsah',
        preparing: 'Sekciu pripravujeme',
        today: 'Dnes',
        week_from: 'Týždeň od',
        data_saved: 'Dáta uložené',
        no_changes_to_save: 'Žiadne zmeny na uloženie',
        channel: 'Kanál',
        hotel_code: 'Kód hotela',
        welcome_in: 'Vitajte v',

        //Splash
        version: 'verzia',
        email: 'E-mail',
        phone: 'Telefón',
        username: 'Prihlasovacie meno',
        password: 'Heslo',
        login: 'Prihlásiť sa',
        USER_NOT_FOUND: 'Neplatný login alebo heslo',
        SERVER_TIMEOUT: 'Server nezodpovedá, skúste to neskôr',
        CONNECTION_ERROR: 'Chyba spojenia, skúste to neskôr',
        FAIL2BAN: 'Prekročený počet neplatných prihlásení. Prihláste sa prosím neskôr',

        //Overview
        basic_information: 'Základné informácie',
        free_occupied_rooms: 'Voľné/Obsadené izby',
        arrivals: 'Príchody',
        arrivals_remaining: 'Zostávajúce príchody',
        arrivals_total: 'Celkové',
        remaining_only: 'Iba zostávajúce',
        departures: 'Odchody',
        departures_remaining: 'Zostávajúce odchody',
        departures_total: 'Celkové',
        todays_options: 'Dnešné opcie',
        waitings: 'Waitingy',
        average_price: 'Priemerná cena',
        thirty_day_occupancy: 'Obsadenosť 30 dní',
        occupancy: 'Obsadenosť',
        occupancy_from: 'Obsadenosť od',
        occupancy_graph: 'Graf obsadenosti izieb',
        occupancy_graph_free: 'Voľné',
        occupancy_graph_occupied: 'Obsadené',
        earnings: 'Tržby',
        received_bookings: 'Prijaté rezervácie',
        graph: 'Graf',
        graph_remaining_arrivals: 'Zostávajúce pr.',
        graph_occupied: 'Bývajúce',
        graph_departures: 'Zostávajúce odch.',
        graph_fault: 'Porucha',
        graph_free: 'Voľné izby',
        days_1: 'Deň',
        days_2: 'Dni',
        days: 'Dní',
        graph_months: 'Mes.',
        graph_year: 'Rok',
        online_only: 'Iba online',
        today_only: 'Iba dnešné',
        history: 'História',
        forecast: 'Výhľad',
        no_permission: 'Nemáte oprávnenie',
        no_permission_for_display: 'Na zobrazenie hodnôt nemáte dostatočné práva.',
        no_results: 'Žiadne výsledky',
        unknown_error: 'Vyskytla sa neočakávaná chyba, skúste stránku načítať znova.',

        //Bookings
        new_booking: 'Nová rezervácia',
        new_bookings: 'Nové rezervácie',
        bookings_overview: 'Prehľad rezervácií',
        bookings_overview_all: 'Prehľad všetkých rezervácií',

        channel_manager: 'Správca kanálov - tabuľka',
        channel_calendar: 'Správca kanálov - kalendár',
        edit_booking: 'Editácia rezervácie',
        save_booking: 'Uložiť rezerváciu',
        cancel_booking: 'Storno rezervácie',
        uncancel_booking: 'Zrušiť storno rezervácie',

        //Booking edit/creation
        label: 'Názov',
        source: 'Zdroj',
        order_num: 'Číslo obj.',
        order_email: 'E-mail',
        group: 'Skupina',
        arrival: 'Príchod',
        departure: 'Odchod',
        room_type: 'Typ izby',
        number_of_rooms: 'Počet izieb',
        number_of_people: 'Počet osôb',
        rooms_state: 'Stav izieb',
        rooms_state_cleaned: 'Upratané',
        rooms_state_not_cleaned: 'Neupratané',
        rooms_state_fault: 'Porucha',
        pricelist: 'Cenník',
        price_type: 'Typ ceny',
        price_mask: 'Maska cien',

        //Channel Manager
        rooms: 'Izby',
        free: 'Voľné',
        fix: 'Fix',
        opce: 'Opcie',
        tentative: 'Tentative',
        free_rooms: 'Voľné izby',
        confirmed: 'Potvrdené',
        unconfirmed: 'Nepotvrdené',
        tri: 'TRI',
        dbl: 'DBL',
        sgl: 'SGL',
        total: 'Celkom',
        faults: 'Poruchy',
        note: 'Poznámka',
        note_abbr: 'Pozn.',
        save: 'Uložiť',
        disable_dependency: 'Zrušiť závislosť',
        close: 'Zavrieť',
        enable_dependency: 'Povoliť závislosť',
        open: 'Otvoriť',

        //Guests
        current_guests: 'Aktuálne bývajúce izby/hostia',
        expected_guests: 'Očakávané bývajúce izby/hostia',
        current_occupancy_today: 'Dnešné obsadené izby/hostia',
        current_guests_short: 'Bývajúce',
        guests_structure: 'Štruktúra hostí',
        guests_structure_foreigners: 'Cudzinci',
        guests_structure_natives: 'Tuzemci',
        guests_structure_groups: 'Skupiny',
        guests_structure_individuals: 'Jednotlivci',

        //Check-in
        accept_without_booking: 'Príjem bez rezervácie',

        //Checkin edit/new
        accommodation: 'Ubytovanie',
        accommodate: 'Ubytovať',
        room_number: 'Číslo izby',
        guest: 'Hosť',
        main: 'hlavné',
        guest_details: 'Detaily hosťa',
        name: 'Meno',
        surname: 'Priezvisko',
        street: 'Ulica',
        street_number: 'Číslo popisné',
        city: 'Mesto',
        postal_code: 'PSČ',
        country: 'Krajina',
        citizenship: 'Štátne občianstvo',
        purpose_of_stay: 'Účel pobytu',
        date_of_birth: 'Dátum narodenia',
        place_of_birth: 'Miesto narodenia',
        id_number: 'Číslo dokladu',
        visa: 'Vízum',
        plate_number: 'Registračná značka',
        add_guest: 'Pridať hosťa',
        price_code: 'Kód ceny',
        price_per_day: 'Cena/deň',
        price_total: 'Cena/celkom',
        payment_method: 'Spôsob platby',
        gdpr_agreement: 'Súhlas s GDPR',
        signature: 'Podpis',
        room_numbers: 'Čísla izieb',
        select_channel_in_settings: 'Vyberte kanál v nastavení',

        //Settings
        settings: 'Nastavenia',
        logout: 'Odhlásiť',
        default_channel: 'Channel manager',
        show_decimals: 'Zobrazovať desatinné miesta',
        show_tentative: 'Show Tentative reservations',

        //Settings charts
        daily: 'Denný',
        monthly: 'Mesačný',
        chart_settings: 'Nastavenie grafu',

        //Nav Menu Items
        hotel: 'Hotel',
        bookings: 'Rezervácia',
        guests: 'Hostia',
        accommodated: 'Bývajúcí',
        checkin: 'Check-in',
        reports: 'Reporty',

        //Day names
        Mon: 'Po',
        Tue: 'Ut',
        Wed: 'St',
        Thu: 'Št',
        Fri: 'Pi',
        Sat: 'So',
        Sun: 'Ne',

        mon: 'Po',
        tue: 'Ut',
        wed: 'St',
        thu: 'Št',
        fri: 'Pi',
        sat: 'So',
        sun: 'Ne',

        Mo: 'Po',
        Tu: 'Ut',
        We: 'St',
        Th: 'Št',
        Fr: 'Pi',
        Sa: 'So',
        Su: 'Ne',

        monday: 'Pondelok',
        tuesday: 'Utorok',
        wednesday: 'Streda',
        thursday: 'Štvrtok',
        friday: 'Piatok',
        saturday: 'Sobota',
        sunday: 'Nedeľa',

        //Prepositions
        from: 'Od',
        to: 'Do',

        obsazenost: 'Obsadenosť',
        obsazenost_v_procentech: 'Obsadenosť v %',
        trzby: 'Tržby',
        minimum_price: 'Minimálna cena',

        //Pull to refresh
        pullText: 'Stiahnuť na aktualizáciu',
        triggerText: 'Pustite na aktualizáciu',
        loadingText: 'Načítam',
        doneText: 'Načítané',
        failText: 'Chyba načítania',

        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'Mar',
        Apr: 'Apr',
        May: 'Máj',
        Jun: 'Jún',
        Jul: 'Júl',
        Aug: 'Aug',
        Sep: 'Sep',
        Oct: 'Okt',
        Nov: 'Nov',
        Dec: 'Dec',

        nothing_found: 'Nič nenájdené',
        ok: 'OK',
        login_expired: 'Vaše prihlásenie vypršalo. Pre pokračovanie sa znova prihláste',
        hotel_not_found: 'Hotel nenájdený',
        room_already_booked: 'Izba je v tomto období už obsadená',
        room_graph: 'Graf izieb',
        create_reservation: 'Vytvoriť rezerváciu',
        blocation: 'Blokácia',
        cancel: 'Zrušiť',
        floor: 'Poschodie',
        account_num: 'Účet č.',
        save_room: 'Uložiť izbu',
        room_saved: 'Izba uložená',
        master: 'Hlavný',
        address: 'Adresa',
        house_number: 'Číslo popisné',
        zip_code: 'PSČ',
        other_info: 'Ďalšie údaje',
        reason: 'Dôvod',
        out_of_order: 'Izba mimo prevádzku',
        finalize: 'Uzavreté',
        guest_card: 'Karta profilu',
        price_per_room_and_night: 'Cena za izbu a noc',
        unlimited: 'Neobmedzene',
        really_cancel: 'Naozaj chcete stornovat rezerváciu?',
        really_restore: 'Naozaj si prajete zrušiť storno rezervácie?',
        reservation_restored: 'Storno zrušené',
        error_restoring_reservation: 'Chyba pri rušení storna rezervácie',
        reservation_canceled: 'Rezervácia stornovaná',
        error_canceling_reservation: 'Chyba pri rušení rezervácie',
        yes: 'Áno',
        no: 'Nie',
        create_checkin: 'Ubytovať',
        checkin_done: 'Ubytovanie dokončené',
        checkin_disabled_message: 'Izbu je možné ubytovať, ak sú vyplnené povinné údaje o hosťovi – precheckin (<i class="icon icon--person-check-fill"></i>) a ak je pridelené číslo izby.',
        save_prices: 'Uložiť ceny',
        fill_all_prices: 'Je potrebné vyplniť všetky položky masky cien',
        no_rooming_checkin: 'Rezervácia nemá pridelené izby. Ak chcete rezerváciu vybaviť, upravte ju a priraďte všetkým hosťom izby.',
        edit_reservation: 'Upraviť rezerváciu'
    }
}



// WEBPACK FOOTER //
// ./src/translations/index.js